module.exports = __webpack_public_path__ + "img/ex13.7d734765.png";